import { render, staticRenderFns } from "./ModalReciboFerias.vue?vue&type=template&id=184e4214&scoped=true"
import script from "./ModalReciboFerias.vue?vue&type=script&lang=js"
export * from "./ModalReciboFerias.vue?vue&type=script&lang=js"
import style0 from "./ModalReciboFerias.vue?vue&type=style&index=0&id=184e4214&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184e4214",
  null
  
)

export default component.exports